import { Entry } from 'contentful';
import { IBlogAuthorFields } from 'global';
import type { ArticleCard } from 'modules/magazine/contentful';
import Breadcrumb from 'modules/magazine/common/breadcrumb';
import BlogTile from 'modules/magazine/magazine-home/blog-tile';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Image from '../components/image';

interface IAuthor extends IBlogAuthorFields {
  articles: Entry<ArticleCard>[] | undefined;
}

const Author: React.FC<IAuthor> = (props) => {
  const { name, subtitle, image, bio, articles } = props;

  return (
    <>
      <section className="bg-background-default container" data-test="author-page">
        <div className="flex py-4 text-lg font-medium lg:py-8 lg:text-[16px]">
          <Breadcrumb author={props} />
        </div>
        <div className="relative w-full lg:container lg:px-8">
          <div className="lg:bg-other-white relative w-full lg:rounded-xl">
            <div className="relative">
              <div className="relative h-56 md:block lg:w-2/12">
                <Image
                  className="relative z-10 w-full lg:rounded-l-xl"
                  data-test="author-image"
                  layout="fill"
                  objectFit="cover"
                  {...image}
                />
              </div>
            </div>
            <div className="lg z-30 -mt-12 w-full md:absolute md:top-0 md:mt-0 md:flex md:h-88 md:items-center lg:z-0">
              <div className="relative w-full px-4 lg:inset-x-12 lg:-inset-y-20 lg:flex lg:justify-start lg:p-0 lg:px-48">
                <div className="bg-other-white relative z-30 rounded-xl p-4 text-left md:rounded-lg lg:bg-transparent">
                  <h1 className="text-primary-main text-3xl font-black lg:col-span-2 lg:mb-0 lg:text-[35px]">
                    {name}
                  </h1>
                  <h3 className="text-grey-900 lg:text-primary-main text-xl font-black lg:text-[20px]">
                    {subtitle}
                  </h3>
                  <p className="text-grey-900 col-span-2 row-span-2 mt-2 mb-2 text-lg font-extralight lg:text-[18px] lg:leading-6">
                    {bio}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-primary-main mb-4 pt-12 pl-4 text-2xl leading-tight font-black lg:mb-12 lg:pl-8 lg:text-3xl">
          <FormattedMessage id="magazine:author-page:title" values={{ name }} />
        </h2>
        <div className="flex flex-col">
          <div className="container grid lg:grid-cols-3">
            {articles?.map((post) => (
              <div key={post.fields.handle} className="mb-6 lg:mr-6">
                <BlogTile article={post.fields} isMagazineHome />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Author;
